import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Dealers_Duplicates_Object} state
 *  @property {object} model
 *  @property {Dealers_Duplicates_Properties} model.properties
 *  @property {Dealers_Duplicates_Is} model.is
 *  @property {Dealers_Duplicates_Has} model.has
 */
export default class DealerCompareObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Dealers_Duplicates._name);
	}

	/**
	 * @param {Dealers_Duplicates_Object} data
	 */
	loadSelfAfter = (data) => {
		// noinspection JSValidateTypes
		/** @type {Dealers_Duplicates_Object} stateUpdate */
		let stateUpdate = {};
		// noinspection JSUnresolvedVariable
		if (data.originals) {
			// noinspection JSValidateTypes
			/** @type {Dealers_Object} original */
			let original = data.originals;
			stateUpdate.original_name_first = original.name_first;
			stateUpdate.original_name_last = original.name_last;
			stateUpdate.original_name_company = original.name_company;
			stateUpdate.original_ffl = original.ffl;
			stateUpdate.original_street_1= original.street_1;
			stateUpdate.original_steet_2 = original.street_2;
			stateUpdate.original_state = original.state;
			stateUpdate.original_county = original.county
			stateUpdate.original_zip = original.zip
			stateUpdate.original_number_main = original.number_main
			stateUpdate.original_number_mobile = original.number_mobile
			stateUpdate.original_email = original.email
		}
		this.setState(stateUpdate);
	};
	async handleSubmit(event, suppressToast = false, suppressProcess = false) {
			this.update = 'POST';
		await super.handleSubmit(event, suppressToast, suppressProcess);
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.props.history.push('/Dealers/' + data.binary_id + "-" + data.pkey + '#details');
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Dealers_Duplicates_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dealers_Duplicates_Object} object */
		let object = this.state;
		return (
			<div>
				<div className={"row"}>
					<div className={"col-md"}>
						<h4 className="section-title">Dealer (Current)</h4>
						<fieldset disabled={true}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Company Name"}
									property={properties.original_name_company}
									value={object.original_name_company}
									error={object.original_name_company_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"FFL"}
									property={properties.original_ffl}
									value={object.original_ffl}
									error={object.original_ffl_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#region Contact Information*/}
							<h4 className="section-title">Contact Information</h4>
							<div className={"row"}>
								<div className={"col-6"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.number_main}
											value={object.number_main}
											error={object.number_main_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-6"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.number_mobile}
											value={object.number_mobile}
											error={object.number_mobile_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
							<div className={"form-group"}>
								<h4 className="section-title">Address</h4>
								<Parts.Address
									object={object}
									properties={properties}
									onTextUpdate={this.handleTextFieldPropertyUpdate}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									prefix={'original_'}
									disableSelect ={true}
								/>
							</div>
						</fieldset>
					</div>
					<div className={"col-md"}>
						<div className="section-title">
							<h4 className="section-title">Dealer (Possible Duplicate)</h4>
							<a href={'/dealers/' + object.binary_id + '-' + object.pkey + '#details'}><Button color="info">View</Button></a>
						</div>
						<fieldset disabled={true}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Company Name"}
									property={properties.name_company}
									value={object.name_company}
									error={object.name_company_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"FFL"}
									property={properties.ffl}
									value={object.ffl}
									error={object.ffl_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#region Contact Information*/}
							<h4 className="section-title">Contact Information</h4>
							<div className={"row"}>
								<div className={"col-6"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.original_number_main}
											value={object.original_number_main}
											error={object.original_number_mobile_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-6"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.original_number_mobile}
											value={object.original_number_mobile}
											error={object.original_number_mobile_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.original_email}
									value={object.original_email}
									error={object.original_email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{/*#endregion*/}
							<div className={"form-group"}>
								<h4 className="section-title">Address</h4>
								<Parts.Address
									object={object}
									properties={properties}
									onTextUpdate={this.handleTextFieldPropertyUpdate}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									disableSelect ={true}
								/>
							</div>
						</fieldset>
					</div>
					<div className={"row"}>
						<div className={"form-group"} style={{padding: "5px"}}>
							<p align={"center"}>Merging Dealers will save the information from the one with the most
								recent transaction. All past transaction will be reassigned to the correct customer entry. <b>This
									WILL NOT change bound book entries, acquisitions, or dispositions.</b> If changes are required
								to Dealers information they must be made directly to the transaction. Merging duplicate customers
								will help insure accurate Multiple Sale reports.
							</p>
						</div>
					</div>
				</div>

			</div>
		)
	}
}
